<app-sub-product-list [isIt]="true" [subProducts]="subProducts"> </app-sub-product-list>
